<template>
  <tr>
    <td>
      <v-select
        v-model="obj.race_type"
        :items="recordsRaceTypesStringsOptions"
        label="Rodzaj"
        :error="hasErrors('race_type')"
        :error-messages="getErrors('race_type')"
      >
      </v-select>
    </td>
    <td>
      <v-select
          v-model="obj.distance_string"
          label="Dystans"
          :items="distanceOptions"
          :error="hasErrors('distance_string')"
          :error-messages="getErrors('distance_string')"
      >
      </v-select>
    </td>
    <td>
      <v-text-field
          v-model="obj.time"
          label="Czas"
          placeholder="hh:mm:ss"
          :error="hasErrors('time')"
          :error-messages="getErrors('time')"
      >
      </v-text-field>
    </td>
    <td>
      <input-date
          v-model="obj.race_date"
          label="Data"
          :error="hasErrors('race_date')"
          :error-messages="getErrors('race_date')"
      >
      </input-date>
    </td>
    <td>
      <rp-icon
        type="save"
        tooltip="zapisz"
        class="mr-1"
        @click.native.prevent.stop="saveRecord"
      />
      <rp-icon
        type="undo"
        tooltip="anuluj"
        class="mr-1"
        @click.native.prevent.stop="$emit('close')"
      />
    </td>
  </tr>
</template>
<script>
import moment from 'moment'
import {createRecord, updateRecord} from '../plan/api'
import { mapGetters } from 'vuex'
import InputDate from '@/forms/InputDate'

export default {
  components: {InputDate},
  props: {
    record: {
      type: Object,
      default: function () {
        return {
          race_date: moment().format('YYYY-MM-DD')
        }
      }
    }
  },
  data () {
    return {
      errors: {},
      obj: {}
    }
  },
  computed: {
    ...mapGetters(['recordsRaceTypesStringsOptions', 'measurableRaceDistanceStreetStringsOptions', 'raceDistanceTrackStringsOptions', 'runner']),
    isNew () {
      return this.obj.id === undefined
    },
    distanceOptions () {
      if (this.obj.race_type === 'street') {
        return this.measurableRaceDistanceStreetStringsOptions
      }
      if (this.obj.race_type === 'track') {
        return this.raceDistanceTrackStringsOptions
      }
      return [
      ]
    }
  },
  created () {
    this.initRecord()
  },
  methods: {
    initRecord () {
      this.obj = {...this.record}
    },
    saveRecord () {
      if (this.isNew) {
        var promise = createRecord(this.runner, this.obj).then((data) => {
          this.$emit('created-record', data)
          return data
        })
      } else {
        promise = updateRecord(this.runner, this.obj).then((data) => {
          this.$emit('updated-record', data, this.record)
          return data
        })
      }
      promise.catch((data) => {
        if (data.response.status === 400) {
          this.errors = data.response.data
        }
      })
    },
    getErrors (name) {
      return this.errors[name] || []
    },
    hasErrors (name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0
    },
    resetErrors () {
      this.errors = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/results/RecordForm.vue